const env = {
  SERVER: process.env.REACT_APP_API_URL,
  API_URL: process.env.REACT_APP_API_URL + '/api',
  G_MAP_API_KEY: process.env.REACT_APP_G_MAP_API_KEY,
}

export default env
